import { render, staticRenderFns } from "./PrincipalBar.vue?vue&type=template&id=07f13bd9&"
import script from "./PrincipalBar.vue?vue&type=script&lang=js&"
export * from "./PrincipalBar.vue?vue&type=script&lang=js&"
import style0 from "./PrincipalBar.vue?vue&type=style&index=0&id=07f13bd9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports